import { DateTimeInput, Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { DATETIME_INPUT_COLUMN_WIDTH } from 'Components/Layout/Grid/types';
import { IWorksheetComponent, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { DateTimeDataFormat } from 'Lib/Format';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';

let BsEnPortionDryMassReadings: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const showSingleReadingSection = useSelector(
    pipe(
      createWorksheetSelector!('DryingTray.DryMassReadings'),
      (r) => (r?.length ?? 0) <= 1 && dryMassEntryOption === 'Never'
    )
  );

  return (
    <>
      {showSingleReadingSection ? (
        <ListFieldSection>
          <Field
            input={<NumericInput />}
            name="DryingTray.DryMassReadings.0.DrySoilAndContainerMass"
            // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
            additionalMessagePaths={['DryingTray.DryMassReadings.0.DrySoilMass']}
          />
        </ListFieldSection>
      ) : (
        <WorksheetGridFieldSection name="DryingTray.DryMassReadings">
          <WorksheetRecordGrid
            name="DryingTray.DryMassReadings"
            orientation={'vertical'}
            recordProps={{
              enforceAtLeastOneRecord: true,
              preventRemove: 'all-but-last',
              removeConfirm: {
                confirm: true,
                confirmTitle: 'Delete Dry Mass Reading',
                confirmText: 'Are you sure you want to delete the dry mass reading? Data cannot be recovered.',
                confirmButtonText: 'Delete',
              },
            }}
            fieldSet={[
              {
                name: 'DateTimeRemovedFromOvenLocal',
                component: <Field input={<DateTimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
                width: DATETIME_INPUT_COLUMN_WIDTH,
              },
              {
                name: 'DryingTime',
                component: <Field input={<TextOutput />} />,
              },
              {
                name: 'DrySoilAndContainerMass',
                component: <Field input={<NumericInput />} />,
                additionalMessagePaths: ['DrySoilMass'],
              },
            ]}
          />
        </WorksheetGridFieldSection>
      )}
    </>
  );
};

BsEnPortionDryMassReadings = withInjectedProps(BsEnPortionDryMassReadings);

export { BsEnPortionDryMassReadings };
export default BsEnPortionDryMassReadings;
